var map = {
	"./design/colors/engineering/BackgroundBadOptimized.jp2": 190,
	"./design/colors/engineering/BackgroundBadOptimized.png": 191,
	"./design/colors/engineering/BackgroundBadOptimized.webp": 192,
	"./design/colors/engineering/BackgroundGoodOptimized.jp2": 193,
	"./design/colors/engineering/BackgroundGoodOptimized.png": 194,
	"./design/colors/engineering/BackgroundGoodOptimized.webp": 195,
	"./design/colors/engineering/ContrastBadOptimized.jp2": 196,
	"./design/colors/engineering/ContrastBadOptimized.png": 197,
	"./design/colors/engineering/ContrastBadOptimized.webp": 198,
	"./design/colors/engineering/ContrastGoodOptimized.jp2": 199,
	"./design/colors/engineering/ContrastGoodOptimized.png": 200,
	"./design/colors/engineering/ContrastGoodOptimized.webp": 201,
	"./design/colors/engineering/HighlightBadOptimized.jp2": 202,
	"./design/colors/engineering/HighlightBadOptimized.png": 203,
	"./design/colors/engineering/HighlightBadOptimized.webp": 204,
	"./design/colors/engineering/HighlightGoodOptimized.jp2": 205,
	"./design/colors/engineering/HighlightGoodOptimized.png": 206,
	"./design/colors/engineering/HighlightGoodOptimized.webp": 207,
	"./design/colors/engineering/SimpleBadOptimized.jp2": 208,
	"./design/colors/engineering/SimpleBadOptimized.png": 209,
	"./design/colors/engineering/SimpleBadOptimized.webp": 210,
	"./design/colors/engineering/SimpleGoodOptimized.jp2": 211,
	"./design/colors/engineering/SimpleGoodOptimized.png": 212,
	"./design/colors/engineering/SimpleGoodOptimized.webp": 213,
	"./design/colors/engineering/WhitespaceBadOptimized.jp2": 214,
	"./design/colors/engineering/WhitespaceBadOptimized.png": 215,
	"./design/colors/engineering/WhitespaceBadOptimized.webp": 216,
	"./design/colors/engineering/WhitespaceGoodOptimized.jp2": 217,
	"./design/colors/engineering/WhitespaceGoodOptimized.png": 218,
	"./design/colors/engineering/WhitespaceGoodOptimized.webp": 219,
	"./design/colors/engineering/originals/BackgroundBad.png": 220,
	"./design/colors/engineering/originals/BackgroundGood.png": 221,
	"./design/colors/engineering/originals/ContrastBad.png": 222,
	"./design/colors/engineering/originals/ContrastGood.png": 223,
	"./design/colors/engineering/originals/HighlightBad.png": 224,
	"./design/colors/engineering/originals/HighlightGood.png": 225,
	"./design/colors/engineering/originals/SimpleBad.png": 226,
	"./design/colors/engineering/originals/SimpleGood.png": 227,
	"./design/colors/engineering/originals/WhitespaceBad.png": 228,
	"./design/colors/engineering/originals/WhitespaceGood.png": 229,
	"./design/colors/humanities/BackgroundBadOptimized.jp2": 230,
	"./design/colors/humanities/BackgroundBadOptimized.png": 231,
	"./design/colors/humanities/BackgroundBadOptimized.webp": 232,
	"./design/colors/humanities/BackgroundGoodOptimized.jp2": 233,
	"./design/colors/humanities/BackgroundGoodOptimized.png": 234,
	"./design/colors/humanities/BackgroundGoodOptimized.webp": 235,
	"./design/colors/humanities/ContrastBadOptimized.jp2": 236,
	"./design/colors/humanities/ContrastBadOptimized.png": 237,
	"./design/colors/humanities/ContrastBadOptimized.webp": 238,
	"./design/colors/humanities/ContrastGoodOptimized.jp2": 239,
	"./design/colors/humanities/ContrastGoodOptimized.png": 240,
	"./design/colors/humanities/ContrastGoodOptimized.webp": 241,
	"./design/colors/humanities/HighlightBadOptimized.jp2": 242,
	"./design/colors/humanities/HighlightBadOptimized.png": 243,
	"./design/colors/humanities/HighlightBadOptimized.webp": 244,
	"./design/colors/humanities/HighlightGoodOptimized.jp2": 245,
	"./design/colors/humanities/HighlightGoodOptimized.png": 246,
	"./design/colors/humanities/HighlightGoodOptimized.webp": 247,
	"./design/colors/humanities/SimpleBadOptimized.jp2": 248,
	"./design/colors/humanities/SimpleBadOptimized.png": 249,
	"./design/colors/humanities/SimpleBadOptimized.webp": 250,
	"./design/colors/humanities/SimpleGoodOptimized.jp2": 251,
	"./design/colors/humanities/SimpleGoodOptimized.png": 252,
	"./design/colors/humanities/SimpleGoodOptimized.webp": 253,
	"./design/colors/humanities/WhitespaceBadOptimized.jp2": 254,
	"./design/colors/humanities/WhitespaceBadOptimized.png": 255,
	"./design/colors/humanities/WhitespaceBadOptimized.webp": 256,
	"./design/colors/humanities/WhitespaceGoodOptimized.jp2": 257,
	"./design/colors/humanities/WhitespaceGoodOptimized.png": 258,
	"./design/colors/humanities/WhitespaceGoodOptimized.webp": 259,
	"./design/colors/humanities/originals/BackgroundBad.png": 260,
	"./design/colors/humanities/originals/BackgroundGood.png": 261,
	"./design/colors/humanities/originals/ContrastBad.png": 262,
	"./design/colors/humanities/originals/ContrastGood.png": 263,
	"./design/colors/humanities/originals/HighlightBad.png": 264,
	"./design/colors/humanities/originals/HighlightGood.png": 265,
	"./design/colors/humanities/originals/SimpleBad.png": 266,
	"./design/colors/humanities/originals/SimpleGood.png": 267,
	"./design/colors/humanities/originals/WhitespaceBad.png": 268,
	"./design/colors/humanities/originals/WhitespaceGood.png": 269,
	"./design/colors/science/BackgroundBadOptimized.jp2": 270,
	"./design/colors/science/BackgroundBadOptimized.png": 271,
	"./design/colors/science/BackgroundBadOptimized.webp": 272,
	"./design/colors/science/BackgroundGoodOptimized.jp2": 273,
	"./design/colors/science/BackgroundGoodOptimized.png": 274,
	"./design/colors/science/BackgroundGoodOptimized.webp": 275,
	"./design/colors/science/ContrastBadOptimized.jp2": 276,
	"./design/colors/science/ContrastBadOptimized.png": 277,
	"./design/colors/science/ContrastBadOptimized.webp": 278,
	"./design/colors/science/ContrastGoodOptimized.jp2": 279,
	"./design/colors/science/ContrastGoodOptimized.png": 280,
	"./design/colors/science/ContrastGoodOptimized.webp": 281,
	"./design/colors/science/HighlightBadOptimized.jp2": 282,
	"./design/colors/science/HighlightBadOptimized.png": 283,
	"./design/colors/science/HighlightBadOptimized.webp": 284,
	"./design/colors/science/HighlightGoodOptimized.jp2": 285,
	"./design/colors/science/HighlightGoodOptimized.png": 286,
	"./design/colors/science/HighlightGoodOptimized.webp": 287,
	"./design/colors/science/SimpleBadOptimized.jp2": 288,
	"./design/colors/science/SimpleBadOptimized.png": 289,
	"./design/colors/science/SimpleBadOptimized.webp": 290,
	"./design/colors/science/SimpleGoodOptimized.jp2": 291,
	"./design/colors/science/SimpleGoodOptimized.png": 292,
	"./design/colors/science/SimpleGoodOptimized.webp": 293,
	"./design/colors/science/WhitespaceBadOptimized.jp2": 294,
	"./design/colors/science/WhitespaceBadOptimized.png": 295,
	"./design/colors/science/WhitespaceBadOptimized.webp": 296,
	"./design/colors/science/WhitespaceGoodOptimized.jp2": 297,
	"./design/colors/science/WhitespaceGoodOptimized.png": 298,
	"./design/colors/science/WhitespaceGoodOptimized.webp": 299,
	"./design/colors/science/originals/BackgroundBad.png": 300,
	"./design/colors/science/originals/BackgroundGood.png": 301,
	"./design/colors/science/originals/ContrastBad.png": 302,
	"./design/colors/science/originals/ContrastGood.png": 303,
	"./design/colors/science/originals/HighlightBad.png": 304,
	"./design/colors/science/originals/HighlightGood.png": 305,
	"./design/colors/science/originals/SimpleBad.png": 306,
	"./design/colors/science/originals/SimpleGood.png": 307,
	"./design/colors/science/originals/WhitespaceBad.png": 308,
	"./design/colors/science/originals/WhitespaceGood.png": 309,
	"./design/fonts/engineering/SerifBadOptimized.jp2": 310,
	"./design/fonts/engineering/SerifBadOptimized.png": 311,
	"./design/fonts/engineering/SerifBadOptimized.webp": 312,
	"./design/fonts/engineering/SerifGoodOptimized.jp2": 313,
	"./design/fonts/engineering/SerifGoodOptimized.png": 314,
	"./design/fonts/engineering/SerifGoodOptimized.webp": 315,
	"./design/fonts/engineering/SizeBadOptimized.jp2": 316,
	"./design/fonts/engineering/SizeBadOptimized.png": 317,
	"./design/fonts/engineering/SizeBadOptimized.webp": 318,
	"./design/fonts/engineering/SizeGoodOptimized.jp2": 319,
	"./design/fonts/engineering/SizeGoodOptimized.png": 320,
	"./design/fonts/engineering/SizeGoodOptimized.webp": 321,
	"./design/fonts/engineering/originals/SerifBad.png": 322,
	"./design/fonts/engineering/originals/SerifGood.png": 323,
	"./design/fonts/engineering/originals/SizeBad.png": 324,
	"./design/fonts/engineering/originals/SizeGood.png": 325,
	"./design/fonts/humanities/SerifBadOptimized.jp2": 326,
	"./design/fonts/humanities/SerifBadOptimized.png": 327,
	"./design/fonts/humanities/SerifBadOptimized.webp": 328,
	"./design/fonts/humanities/SerifGoodOptimized.jp2": 329,
	"./design/fonts/humanities/SerifGoodOptimized.png": 330,
	"./design/fonts/humanities/SerifGoodOptimized.webp": 331,
	"./design/fonts/humanities/SizeBadOptimized.jp2": 332,
	"./design/fonts/humanities/SizeBadOptimized.png": 333,
	"./design/fonts/humanities/SizeBadOptimized.webp": 334,
	"./design/fonts/humanities/SizeGoodOptimized.jp2": 335,
	"./design/fonts/humanities/SizeGoodOptimized.png": 336,
	"./design/fonts/humanities/SizeGoodOptimized.webp": 337,
	"./design/fonts/humanities/originals/SerifBad.png": 338,
	"./design/fonts/humanities/originals/SerifGood.png": 339,
	"./design/fonts/humanities/originals/SizeBad.png": 340,
	"./design/fonts/humanities/originals/SizeGood.png": 341,
	"./design/fonts/science/SerifBadOptimized.jp2": 342,
	"./design/fonts/science/SerifBadOptimized.png": 343,
	"./design/fonts/science/SerifBadOptimized.webp": 344,
	"./design/fonts/science/SerifGoodOptimized.jp2": 345,
	"./design/fonts/science/SerifGoodOptimized.png": 346,
	"./design/fonts/science/SerifGoodOptimized.webp": 347,
	"./design/fonts/science/SizeBadOptimized.jp2": 348,
	"./design/fonts/science/SizeBadOptimized.png": 349,
	"./design/fonts/science/SizeBadOptimized.webp": 350,
	"./design/fonts/science/SizeGoodOptimized.jp2": 351,
	"./design/fonts/science/SizeGoodOptimized.png": 352,
	"./design/fonts/science/SizeGoodOptimized.webp": 353,
	"./design/fonts/science/originals/SerifBad.png": 354,
	"./design/fonts/science/originals/SerifGood.png": 355,
	"./design/fonts/science/originals/SizeBad.png": 356,
	"./design/fonts/science/originals/SizeGood.png": 357,
	"./design/images/engineering/AnimationsBad.gif": 358,
	"./design/images/engineering/AnimationsBadOptimized.mp4": 359,
	"./design/images/engineering/AnimationsBadOptimized.webm": 360,
	"./design/images/engineering/AnimationsGoodOptimized.jp2": 361,
	"./design/images/engineering/AnimationsGoodOptimized.png": 362,
	"./design/images/engineering/AnimationsGoodOptimized.webp": 363,
	"./design/images/engineering/CanBeSeenBadOptimized.jp2": 364,
	"./design/images/engineering/CanBeSeenBadOptimized.png": 365,
	"./design/images/engineering/CanBeSeenBadOptimized.webp": 366,
	"./design/images/engineering/CanBeSeenGoodOptimized.jp2": 367,
	"./design/images/engineering/CanBeSeenGoodOptimized.png": 368,
	"./design/images/engineering/CanBeSeenGoodOptimized.webp": 369,
	"./design/images/engineering/EnrichBadOptimized.jp2": 370,
	"./design/images/engineering/EnrichBadOptimized.png": 371,
	"./design/images/engineering/EnrichBadOptimized.webp": 372,
	"./design/images/engineering/EnrichGoodOptimized.jp2": 373,
	"./design/images/engineering/EnrichGoodOptimized.png": 374,
	"./design/images/engineering/EnrichGoodOptimized.webp": 375,
	"./design/images/engineering/SimpleBadOptimized.jp2": 376,
	"./design/images/engineering/SimpleBadOptimized.png": 377,
	"./design/images/engineering/SimpleBadOptimized.webp": 378,
	"./design/images/engineering/SimpleGoodOptimized.jp2": 379,
	"./design/images/engineering/SimpleGoodOptimized.png": 380,
	"./design/images/engineering/SimpleGoodOptimized.webp": 381,
	"./design/images/engineering/originals/AnimationsBad.mov": 382,
	"./design/images/engineering/originals/AnimationsGood.png": 383,
	"./design/images/engineering/originals/CanBeSeenBad.png": 384,
	"./design/images/engineering/originals/CanBeSeenGood.png": 385,
	"./design/images/engineering/originals/EnrichBad.png": 386,
	"./design/images/engineering/originals/EnrichGood.png": 387,
	"./design/images/engineering/originals/SimpleBad.png": 388,
	"./design/images/engineering/originals/SimpleGood.png": 389,
	"./design/images/engineering/originals/uncropped/AnimationsBad.mov": 390,
	"./design/images/humanities/AnimationsBad.gif": 391,
	"./design/images/humanities/AnimationsBadOptimized.mp4": 392,
	"./design/images/humanities/AnimationsBadOptimized.webm": 393,
	"./design/images/humanities/AnimationsGoodOptimized.jp2": 394,
	"./design/images/humanities/AnimationsGoodOptimized.png": 395,
	"./design/images/humanities/AnimationsGoodOptimized.webp": 396,
	"./design/images/humanities/CanBeSeenBadOptimized.jp2": 397,
	"./design/images/humanities/CanBeSeenBadOptimized.png": 398,
	"./design/images/humanities/CanBeSeenBadOptimized.webp": 399,
	"./design/images/humanities/CanBeSeenGoodOptimized.jp2": 400,
	"./design/images/humanities/CanBeSeenGoodOptimized.png": 401,
	"./design/images/humanities/CanBeSeenGoodOptimized.webp": 402,
	"./design/images/humanities/EnrichBadOptimized.jp2": 403,
	"./design/images/humanities/EnrichBadOptimized.png": 404,
	"./design/images/humanities/EnrichBadOptimized.webp": 405,
	"./design/images/humanities/EnrichGoodOptimized.jp2": 406,
	"./design/images/humanities/EnrichGoodOptimized.png": 407,
	"./design/images/humanities/EnrichGoodOptimized.webp": 408,
	"./design/images/humanities/SimpleBadOptimized.jp2": 409,
	"./design/images/humanities/SimpleBadOptimized.png": 410,
	"./design/images/humanities/SimpleBadOptimized.webp": 411,
	"./design/images/humanities/SimpleGoodOptimized.jp2": 412,
	"./design/images/humanities/SimpleGoodOptimized.png": 413,
	"./design/images/humanities/SimpleGoodOptimized.webp": 414,
	"./design/images/humanities/originals/AnimationsBad.gif": 415,
	"./design/images/humanities/originals/AnimationsBad.mov": 416,
	"./design/images/humanities/originals/AnimationsBadUncropped.gif": 417,
	"./design/images/humanities/originals/AnimationsGood.png": 418,
	"./design/images/humanities/originals/CanBeSeenBad.png": 419,
	"./design/images/humanities/originals/CanBeSeenGood.png": 420,
	"./design/images/humanities/originals/EnrichBad.png": 421,
	"./design/images/humanities/originals/EnrichGood.png": 422,
	"./design/images/humanities/originals/SimpleBad.png": 423,
	"./design/images/humanities/originals/SimpleGood.png": 424,
	"./design/images/science/AnimationsBad.gif": 425,
	"./design/images/science/AnimationsBadOptimized.mp4": 426,
	"./design/images/science/AnimationsBadOptimized.webm": 427,
	"./design/images/science/AnimationsGoodOptimized.jp2": 428,
	"./design/images/science/AnimationsGoodOptimized.png": 429,
	"./design/images/science/AnimationsGoodOptimized.webp": 430,
	"./design/images/science/CanBeSeenBadOptimized.jp2": 431,
	"./design/images/science/CanBeSeenBadOptimized.png": 432,
	"./design/images/science/CanBeSeenBadOptimized.webp": 433,
	"./design/images/science/CanBeSeenGoodOptimized.jp2": 434,
	"./design/images/science/CanBeSeenGoodOptimized.png": 435,
	"./design/images/science/CanBeSeenGoodOptimized.webp": 436,
	"./design/images/science/EnrichBadOptimized.jp2": 437,
	"./design/images/science/EnrichBadOptimized.png": 438,
	"./design/images/science/EnrichBadOptimized.webp": 439,
	"./design/images/science/EnrichGoodOptimized.jp2": 440,
	"./design/images/science/EnrichGoodOptimized.png": 441,
	"./design/images/science/EnrichGoodOptimized.webp": 442,
	"./design/images/science/SimpleBadOptimized.jp2": 443,
	"./design/images/science/SimpleBadOptimized.png": 444,
	"./design/images/science/SimpleBadOptimized.webp": 445,
	"./design/images/science/SimpleGoodOptimized.jp2": 446,
	"./design/images/science/SimpleGoodOptimized.png": 447,
	"./design/images/science/SimpleGoodOptimized.webp": 448,
	"./design/images/science/originals/AnimationsBad.mov": 449,
	"./design/images/science/originals/AnimationsGood.png": 450,
	"./design/images/science/originals/CanBeSeenBad.png": 451,
	"./design/images/science/originals/CanBeSeenGood.png": 452,
	"./design/images/science/originals/EnrichBad.png": 453,
	"./design/images/science/originals/EnrichGood.png": 454,
	"./design/images/science/originals/SimpleBad.png": 455,
	"./design/images/science/originals/SimpleGood.png": 456,
	"./design/text/engineering/7x7BadOptimized.jp2": 457,
	"./design/text/engineering/7x7BadOptimized.png": 458,
	"./design/text/engineering/7x7BadOptimized.webp": 459,
	"./design/text/engineering/7x7GoodOptimized.jp2": 460,
	"./design/text/engineering/7x7GoodOptimized.png": 461,
	"./design/text/engineering/7x7GoodOptimized.webp": 462,
	"./design/text/engineering/TextEnrichesBadOptimized.jp2": 463,
	"./design/text/engineering/TextEnrichesBadOptimized.png": 464,
	"./design/text/engineering/TextEnrichesBadOptimized.webp": 465,
	"./design/text/engineering/TextEnrichesGoodOptimized.jp2": 466,
	"./design/text/engineering/TextEnrichesGoodOptimized.png": 467,
	"./design/text/engineering/TextEnrichesGoodOptimized.webp": 468,
	"./design/text/engineering/TitlesBadOptimized.jp2": 469,
	"./design/text/engineering/TitlesBadOptimized.png": 470,
	"./design/text/engineering/TitlesBadOptimized.webp": 471,
	"./design/text/engineering/TitlesGoodOptimized.jp2": 472,
	"./design/text/engineering/TitlesGoodOptimized.png": 473,
	"./design/text/engineering/TitlesGoodOptimized.webp": 474,
	"./design/text/engineering/originals/7x7Bad.png": 475,
	"./design/text/engineering/originals/7x7Good.png": 476,
	"./design/text/engineering/originals/TextEnrichesBad.png": 477,
	"./design/text/engineering/originals/TextEnrichesGood.png": 478,
	"./design/text/engineering/originals/TitlesBad.png": 479,
	"./design/text/engineering/originals/TitlesGood.png": 480,
	"./design/text/humanities/7x7BadOptimized.jp2": 481,
	"./design/text/humanities/7x7BadOptimized.png": 482,
	"./design/text/humanities/7x7BadOptimized.webp": 483,
	"./design/text/humanities/7x7GoodOptimized.jp2": 484,
	"./design/text/humanities/7x7GoodOptimized.png": 485,
	"./design/text/humanities/7x7GoodOptimized.webp": 486,
	"./design/text/humanities/TextEnrichesBadOptimized.jp2": 487,
	"./design/text/humanities/TextEnrichesBadOptimized.png": 488,
	"./design/text/humanities/TextEnrichesBadOptimized.webp": 489,
	"./design/text/humanities/TextEnrichesGoodOptimized.jp2": 490,
	"./design/text/humanities/TextEnrichesGoodOptimized.png": 491,
	"./design/text/humanities/TextEnrichesGoodOptimized.webp": 492,
	"./design/text/humanities/TitlesBadOptimized.jp2": 493,
	"./design/text/humanities/TitlesBadOptimized.png": 494,
	"./design/text/humanities/TitlesBadOptimized.webp": 495,
	"./design/text/humanities/TitlesGoodOptimized.jp2": 496,
	"./design/text/humanities/TitlesGoodOptimized.png": 497,
	"./design/text/humanities/TitlesGoodOptimized.webp": 498,
	"./design/text/humanities/originals/7x7Bad.png": 499,
	"./design/text/humanities/originals/7x7Good.png": 500,
	"./design/text/humanities/originals/TextEnrichesBad.png": 501,
	"./design/text/humanities/originals/TextEnrichesGood.png": 502,
	"./design/text/humanities/originals/TitlesBad.png": 503,
	"./design/text/humanities/originals/TitlesGood.png": 504,
	"./design/text/science/7x7BadOptimized.jp2": 505,
	"./design/text/science/7x7BadOptimized.png": 506,
	"./design/text/science/7x7BadOptimized.webp": 507,
	"./design/text/science/7x7GoodOptimized.jp2": 508,
	"./design/text/science/7x7GoodOptimized.png": 509,
	"./design/text/science/7x7GoodOptimized.webp": 510,
	"./design/text/science/TextEnrichesBadOptimized.jp2": 511,
	"./design/text/science/TextEnrichesBadOptimized.png": 512,
	"./design/text/science/TextEnrichesBadOptimized.webp": 513,
	"./design/text/science/TextEnrichesGoodOptimized.jp2": 514,
	"./design/text/science/TextEnrichesGoodOptimized.png": 515,
	"./design/text/science/TextEnrichesGoodOptimized.webp": 516,
	"./design/text/science/TitlesBadOptimized.jp2": 517,
	"./design/text/science/TitlesBadOptimized.png": 518,
	"./design/text/science/TitlesBadOptimized.webp": 519,
	"./design/text/science/TitlesGoodOptimized.jp2": 520,
	"./design/text/science/TitlesGoodOptimized.png": 521,
	"./design/text/science/TitlesGoodOptimized.webp": 522,
	"./design/text/science/originals/7x7Bad.png": 523,
	"./design/text/science/originals/7x7Good.png": 524,
	"./design/text/science/originals/TextEnrichesBad.png": 525,
	"./design/text/science/originals/TextEnrichesGood.png": 526,
	"./design/text/science/originals/TitlesBad.png": 527,
	"./design/text/science/originals/TitlesGood.png": 528,
	"./home/BadExampleOptimized.jp2": 529,
	"./home/BadExampleOptimized.png": 530,
	"./home/BadExampleOptimized.webp": 531,
	"./home/CreateOptimized.jp2": 532,
	"./home/CreateOptimized.png": 533,
	"./home/CreateOptimized.webp": 534,
	"./home/DeliverOptimized.jp2": 535,
	"./home/DeliverOptimized.png": 536,
	"./home/DeliverOptimized.webp": 537,
	"./home/DesignOptimized.jp2": 538,
	"./home/DesignOptimized.png": 539,
	"./home/DesignOptimized.webp": 540,
	"./home/DesignTextEnrichesOptimized.jp2": 541,
	"./home/DesignTextEnrichesOptimized.png": 542,
	"./home/DesignTextEnrichesOptimized.webp": 543,
	"./home/FeedbackBotOptimized.jp2": 544,
	"./home/FeedbackBotOptimized.png": 545,
	"./home/FeedbackBotOptimized.webp": 546,
	"./home/GoodExampleOptimized.jp2": 547,
	"./home/GoodExampleOptimized.png": 548,
	"./home/GoodExampleOptimized.webp": 549,
	"./home/GoogleSlidesOptimized.jp2": 550,
	"./home/GoogleSlidesOptimized.png": 551,
	"./home/GoogleSlidesOptimized.webp": 552,
	"./home/MessageOptimized.jp2": 553,
	"./home/MessageOptimized.png": 554,
	"./home/MessageOptimized.webp": 555,
	"./home/PlanOptimized.jp2": 556,
	"./home/PlanOptimized.png": 557,
	"./home/PlanOptimized.webp": 558,
	"./home/PreslyLogoOptimized.jp2": 559,
	"./home/PreslyLogoOptimized.png": 560,
	"./home/PreslyLogoOptimized.webp": 561,
	"./home/originals/BadExample.png": 562,
	"./home/originals/Create.png": 563,
	"./home/originals/Deliver.png": 564,
	"./home/originals/Design.png": 565,
	"./home/originals/DesignTextEnriches.png": 566,
	"./home/originals/FeedbackBot.png": 567,
	"./home/originals/GoodExample.png": 568,
	"./home/originals/GoogleSlides.png": 569,
	"./home/originals/Message.png": 570,
	"./home/originals/Plan.png": 571,
	"./home/originals/PreslyLogo.png": 572,
	"./home/originals/uncropped/CreateUncropped.png": 573,
	"./home/originals/uncropped/DesignSimpleColors.png": 574,
	"./home/originals/uncropped/DesignTextEnriches.png": 575,
	"./home/originals/uncropped/DesignTextEnriches.xcf": 576,
	"./home/originals/uncropped/FeedbackBot.xcf": 577,
	"./home/originals/uncropped/FeedbackBotCroppedWithoutBorder.png": 578,
	"./home/originals/uncropped/FeedbackBotGrayBackground.png": 579,
	"./home/originals/uncropped/FeedbackBotGrayBackground.xcf": 580,
	"./home/originals/uncropped/FeedbackBotUncropped.png": 581,
	"./home/originals/uncropped/Message.xcf": 582,
	"./home/originals/uncropped/MessageGrayBackground.png": 583,
	"./home/originals/uncropped/PlanUncropped.png": 584,
	"./home/testimonials/FloOptimized.jp2": 585,
	"./home/testimonials/FloOptimized.png": 586,
	"./home/testimonials/FloOptimized.webp": 587,
	"./home/testimonials/JakeOptimized.jp2": 588,
	"./home/testimonials/JakeOptimized.png": 589,
	"./home/testimonials/JakeOptimized.webp": 590,
	"./home/testimonials/MayhemOptimized.jp2": 591,
	"./home/testimonials/MayhemOptimized.png": 592,
	"./home/testimonials/MayhemOptimized.webp": 593,
	"./home/testimonials/originals/Flo.png": 594,
	"./home/testimonials/originals/Jake.jpg": 595,
	"./home/testimonials/originals/Mayhem.jpg": 596,
	"./home/testimonials/originals/uncropped/FloUncropped.png": 597,
	"./home/testimonials/originals/uncropped/JakeUncropped.jpeg": 598,
	"./home/testimonials/originals/uncropped/MayhemUncropped.jpeg": 599,
	"./logo.xcf": 600,
	"./logo_alt.png": 601,
	"./logo_alt.xcf": 602,
	"./logo_original.png": 603,
	"./logo_transparent.png": 604,
	"./logo_transparent.xcf": 605,
	"./resources/print_frequencies.py": 606,
	"./resources/wordcloud_list.csv": 607,
	"./resources/wordcloud_list_pruned.csv": 608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;